module.exports = __webpack_public_path__ + "static/rosehat-0b2e96d3c572ab87abf0fff9f0e57e27.jpeg";